<template>
  <div class="common-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>通用设置</BreadcrumbItem>
          <BreadcrumbItem>小程序抽奖设置</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">小程序抽奖设置</div>
      </div>
    </div>
    <div class="box">
      <Form ref="formValidate" :label-width="130" style="width: 1000px">
        <FormItem label=" ">
          <el-radio-group v-model="typeLottery" @change="typeClick()">
            <el-radio-button label="wechat">小程序</el-radio-button>
            <el-radio-button label="pcEn">英文Pc</el-radio-button>
          </el-radio-group>
        </FormItem>
        <FormItem label="关键词：">
          <el-input
            type="textarea"
            :rows="5"
            v-model="keys"
            placeholder="请输入触发抽奖的关键词，多个请用、隔开"
            style="width: 500px"
          ></el-input>
        </FormItem>
        <FormItem label="中奖概率：" prop="mini">
          <el-input type="number" v-model="probability" style="width: 150px">
            <template slot="append">%</template></el-input
          >
          <span style="margin-left: 20px">中奖概率最大值为100%</span>
        </FormItem>
        <FormItem label="匹配产品方式：">
          <el-radio-group
            v-model="radio"
            size="small"
            @change="changeTheme"
            fill="#66b1ff"
          >
            <el-radio label="all">全库随机匹配</el-radio>
            <el-radio label="fixed">固定产品随机匹配</el-radio>
          </el-radio-group>
        </FormItem>
        <FormItem label="" prop="centre"  >
          <Select
            v-model="centre"
            multiple
            style="width: 500px"
            filterable
            :remote-method="remoteMethod1"
            :loading="loading1"
          >
            <Option v-for="item in list" :value="item.id" :key="item.id">{{
                typeLottery=="wechat"?item.name:item.nameEn
            }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div style="padding: 40px 0 0 130px">
        <Button
          style="width: 82px; height: 32px"
          type="primary"
          :loading="loading"
          @click="handleSubmit('formValidate')"
          >保存</Button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import config from "@assets/config.json"; // api
import axios from "axios";

export default {
  name: "host-common-open",
  data() {
    return {
      radio: "all",
      keys: "",
      searchField: "",
      type: 5,
      loading1: false,
      probability: 0,
      list: [],
      oldList: [],
      loading: false,
      exhibition: [],
      mini: [],
      centre: [],
      exList: [], // 展会列表
      agentId: "CD4E8CEF-C6F7-4E72-9132-93161B9E8C43",
      typeLottery: "wechat",
    };
  },
  computed: {
    ...mapGetters({
      getHeader: "getHeader",
      company: "loginModule/getCompany",
      hostExhibition: "hostSetModule/getHostExhibition",
    }),
    // option() {
    //   return {
    //     exhibition: this.exhibition,
    //     centre: this.centre,
    //     mini: this.mini,
    //   };
    // },
    option() {
      return {
        ExhibitionId: this.hostExhibition.id,
        // AgentId: "CD4E8CEF-C6F7-4E72-9132-93161B9E8C43",
        PageSize: 100,
        PageIndex: 1,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "Name",
                  Value: `%${this.searchField}%`,
                },
              },
            ],
          },
        },
      };
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getHostProductByExId: "productModule/getHostProductByExId",
    }),
    changeTheme(val) {
      console.log(val);
    },

    typeClick() {
        this.centre=[]
      this.init();
    },

    async remoteMethod1(query) {
      let that = this;
      if (query !== "") {
        that.loading1 = true;
        that.searchField = query;
        let data = await that.getHostProductByExId(that.option);
        that.loading1 = false;
        that.list = data.items;
      } else {
        this.options1 = [];
      }
    },
    async init() {
      var data1 = await this.getHostProductByExId(this.option);

      console.log("所有产品" + JSON.stringify(this.list));
      console.log(data1, "data1data1data1");

      //获取配置信息
      let typeCan = this.typeLottery == "wechat" ? "wechat" : "pcEn";
      axios
        .get(
          `${config.api.reqApi}/api/LuckyDraw/getByType?type=${typeCan}`,
          this.getHeader
        )
        .then(({ data }) => {
          console.log(data, "data");
          if (data) {
            // data.map((c) => {
            //   if (c.type == "wechat") {
            //       this.keys = c.keys;
            //       this.radio = c.matchingManner;
            //       this.probability = c.probability;
            //       this.typeLottery = c.type;
            //       this.centre = [];
            //       c.prodcutShort.map((item) => {
            //         this.centre.push(item.id);
            //       });
            //       this.oldList = c.prodcutShort;
            //       this.list = this.mergeAndDistinctById(data1.items, this.oldList);
            //   }
            // });
            let res = data[0];
            this.keys = res.keys;
            this.radio = res.matchingManner;
            this.probability = res.probability;
            this.typeLottery = res.type;
            this.centre = [];
            res.prodcutShort.map((item) => {
              this.centre.push(item.id);
            });
            this.oldList = res.prodcutShort;
            this.list = this.mergeAndDistinctById(data1.items, this.oldList);
          }
        });
    },
    mergeAndDistinctById(arr1, arr2) {
      const mergedArr = arr1.concat(arr2);
      const idMap = new Map();

      const result = mergedArr.reduce((acc, item) => {
        if (!idMap.has(item.id)) {
          idMap.set(item.id, true);
          acc.push(item);
        }
        return acc;
      }, []);

      return result;
    },
    handleSubmit() {
      let opt = {
        productIds: this.centre,
        keys: this.keys,
        probability: this.probability,
        matchingManner: this.radio,
        type: this.typeLottery,
      };

      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      });
      let that = this;
      axios
        .post(`${config.api.reqApi}/api/LuckyDraw/CreatOrUpdate`, opt, this.getHeader)
        .then(({ data }) => {
          that.loading = false;
          if (data && data.successed) {
            that.$Message.success("保存成功");
            this.oldList = [];
            that.init();
          } else {
            that.$Message.error("保存失败，请重新尝试");
          }
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.common-ad {
  .header-switch {
    display: flex;
    align-items: center;
    padding: 0 35px 18px 35px;
    background: #fff;

    &-text {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }

    &-box {
      flex: 1;
      text-align: right;
    }
  }

  .box {
    color: #aaa;
    font-size: 14px;
    background-color: #fff;
    margin: 30px;
    padding: 40px;
  }

  /deep/ {
    .ivu-select-multiple .ivu-tag {
      display: block;
    }
  }
}
</style>
